import styles from "@/styles/detail/DetailFixedBar.module.scss";
import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { FC } from "react";
import contactsSvg from "@/utils/svg-icon/contacts";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";
import { TourReadableTO } from "@/models/detail";
import Btn from "@/common/Btn";
import { EBtnType } from "@/models/common/enums";
import { checkRating } from "@/utils/common";
import { useStore } from "@/store/index";
import { formatPrice } from "@/utils/common/formatPrice";
import { useCurrency } from "@/utils/hooks/useCurrency";
import { useCurrencyConversion } from "@/utils/hooks/useCurrencyConversion";

/* eslint-disable no-underscore-dangle */
const DetailFixedBarMobile: FC<{
    isRequestAQuote?: boolean;
    price: number;
    isPremium: boolean;
    packageDetail: TourReadableTO;
    onClick: () => void;
    isButtonDisabled?: boolean;
    days: string;
}> = ({
    price,
    isPremium,
    packageDetail,
    isRequestAQuote,
    isButtonDisabled = false,
    onClick,
    days,
}) => {
    const { FlagLine, ClockLine } = contactsSvg;
    const { StarFilled } = userInterfaceSvg;

    const { rating } = packageDetail;

    const checkedRating = checkRating(rating);
    const { clickConfirmDate } = useStore(state => state.checkoutState);
    const { currency } = useCurrency();
    const { convertPrice } = useCurrencyConversion();

    return (
        <MDBCol
            size={12}
            className={
                isPremium
                    ? styles.sectionBorderPremium
                    : styles.sectionBorderQuality
            }
        >
            <MDBRow className="pb-2 px-0 ">
                <MDBCol className="px-0 d-flex justify-content-center align-content-center">
                    <span className={`${styles.addToCartBoxPrice} pe-0`}>
                        {clickConfirmDate
                            ? formatPrice(
                                  parseFloat(convertPrice(price)),
                                  currency
                              )
                            : `-`}
                    </span>
                </MDBCol>
                <MDBCol className="px-0 d-flex justify-content-center align-content-center">
                    <Btn
                        btnType={EBtnType.TRANSPARENTNOHOVER}
                        onClick={onClick}
                        disabled={isButtonDisabled}
                    >
                        {isRequestAQuote ? "Request a quote" : "Reserve"}
                    </Btn>
                </MDBCol>
            </MDBRow>
            <MDBRow className="p-0">
                <div className="p-0 d-flex justify-content-center gap-3 justify-content-md-around align-content-center">
                    <div>
                        {checkedRating && (
                            <>
                                <span className={styles.cardStarIcon}>
                                    <StarFilled />
                                </span>
                                <span className={styles.starText}>{`${Number(
                                    packageDetail.rating
                                )}`}</span>
                            </>
                        )}
                    </div>
                    <div>
                        <span
                            className={`${styles.cardClockIcon} ${
                                checkedRating ? "" : "ps-2"
                            }`}
                        >
                            <ClockLine className="p-0" />
                        </span>
                        <span
                            className={`${styles.cardSecondaryText} ${
                                checkedRating ? "pe-2" : ""
                            }`}
                        >{`${days} days, ${+days - 1} nights`}</span>
                    </div>
                    <div>
                        <span className={`${styles.flagContainer} ps-2`}>
                            <FlagLine />
                        </span>
                        <span className={styles.cardSecondaryText}>
                            {packageDetail.destinations.length} destinations
                        </span>
                    </div>
                </div>
            </MDBRow>
        </MDBCol>
    );
};
/* eslint-enable no-underscore-dangle */

export default DetailFixedBarMobile;
